// Common chord fingerings for guitar (from low E [6] to high e [1])
// Each entry: array of 6 values. Numbers = fret; 'x' = muted; 0 = open.
// Optional fingers array: 6 values (0 = no finger).
export const CHORDS = {
  // Open majors
  'C':      { frets: ['x', 3, 2, 0, 1, 0], fingers: [0, 3, 2, 0, 1, 0] },
  'D':      { frets: ['x', 'x', 0, 2, 3, 2], fingers: [0, 0, 0, 1, 3, 2] },
  'E':      { frets: [0, 2, 2, 1, 0, 0], fingers: [0, 2, 3, 1, 0, 0] },
  'F':      { frets: [1, 3, 3, 2, 1, 1], fingers: [1, 3, 4, 2, 1, 1], barre: { fret: 1, from: 6, to: 1 } },
  'G':      { frets: [3, 2, 0, 0, 0, 3], fingers: [3, 2, 0, 0, 0, 4] },
  'A':      { frets: ['x', 0, 2, 2, 2, 0], fingers: [0, 0, 1, 2, 3, 0] },
  'B':      { frets: ['x', 2, 4, 4, 4, 2], fingers: [0, 1, 2, 3, 4, 1], barre: { fret: 2, from: 5, to: 1 } },
  // Open minors
  'Am':     { frets: ['x', 0, 2, 2, 1, 0], fingers: [0, 0, 2, 3, 1, 0] },
  'Dm':     { frets: ['x', 'x', 0, 2, 3, 1], fingers: [0, 0, 0, 2, 3, 1] },
  'Em':     { frets: [0, 2, 2, 0, 0, 0], fingers: [0, 2, 3, 0, 0, 0] },
  'Fm':     { frets: [1, 3, 3, 1, 1, 1], fingers: [1, 3, 4, 1, 1, 1], barre: { fret: 1, from: 6, to: 1 } },
  'Gm':     { frets: [3, 5, 5, 3, 3, 3], fingers: [1, 3, 4, 1, 1, 1], barre: { fret: 3, from: 6, to: 1 } },
  'Bm':     { frets: ['x', 2, 4, 4, 3, 2], fingers: [0, 1, 3, 4, 2, 1], barre: { fret: 2, from: 5, to: 1 } },
  'Cm':     { frets: ['x', 3, 5, 5, 4, 3], fingers: [0, 1, 3, 4, 2, 1], barre: { fret: 3, from: 5, to: 1 } },
  'F#m':    { frets: [2, 4, 4, 2, 2, 2], fingers: [1, 3, 4, 1, 1, 1], barre: { fret: 2, from: 6, to: 1 } },
  'C#m':    { frets: ['x', 4, 6, 6, 5, 4], fingers: [0, 1, 3, 4, 2, 1], barre: { fret: 4, from: 5, to: 1 } },
  // 7ths / sus
  'A7':     { frets: ['x', 0, 2, 0, 2, 0], fingers: [0, 0, 2, 0, 3, 0] },
  'B7':     { frets: ['x', 2, 1, 2, 0, 2], fingers: [0, 2, 1, 3, 0, 4] },
  'D7':     { frets: ['x', 'x', 0, 2, 1, 2], fingers: [0, 0, 0, 2, 1, 3] },
  'E7':     { frets: [0, 2, 0, 1, 0, 0], fingers: [0, 2, 0, 1, 0, 0] },
  'G7':     { frets: [3, 2, 0, 0, 0, 1], fingers: [3, 2, 0, 0, 0, 1] },
  'C7':     { frets: ['x', 3, 2, 3, 1, 0], fingers: [0, 3, 2, 4, 1, 0] },
  'Em7':    { frets: [0, 2, 2, 0, 3, 0], fingers: [0, 1, 2, 0, 3, 0] },
  'Am7':    { frets: ['x', 0, 2, 0, 1, 0], fingers: [0, 0, 2, 0, 1, 0] },
  'Dm7':    { frets: ['x', 'x', 0, 2, 1, 1], fingers: [0, 0, 0, 2, 1, 1] },
  'Cmaj7':  { frets: ['x', 3, 2, 0, 0, 0], fingers: [0, 3, 2, 0, 0, 0] },
  'Gmaj7':  { frets: [3, 2, 0, 0, 0, 2], fingers: [3, 1, 0, 0, 0, 2] },
  'F#m7b5': { frets: [2, 'x', 2, 2, 1, 'x'], fingers: [2, 0, 3, 4, 1, 0] },
  'Dsus4':  { frets: ['x', 'x', 0, 2, 3, 3], fingers: [0, 0, 0, 1, 2, 3] },
  'A7sus4': { frets: ['x', 0, 2, 0, 3, 0], fingers: [0, 0, 2, 0, 3, 0] },
  'Asus2':  { frets: ['x', 0, 2, 2, 0, 0], fingers: [0, 0, 1, 2, 0, 0] },
  'Dsus2':  { frets: ['x', 'x', 0, 2, 3, 0], fingers: [0, 0, 0, 1, 2, 0] },
  // Common alterations
  'Bb':     { frets: ['x', 1, 3, 3, 3, 1], fingers: [0, 1, 2, 3, 4, 1], barre: { fret: 1, from: 5, to: 1 } },
  'Eb':     { frets: ['x', 'x', 5, 3, 4, 3], fingers: [0, 0, 4, 1, 3, 2] },
  'Ebm':    { frets: ['x', 'x', 4, 3, 4, 2], fingers: [0, 0, 3, 2, 4, 1] },
  'Bbm7':   { frets: ['x', 1, 3, 1, 2, 1], fingers: [0, 1, 3, 1, 2, 1], barre: { fret: 1, from: 5, to: 1 } },
  // Common suspended and add chords
  'Cadd9':  { frets: ['x', 3, 2, 0, 3, 3], fingers: [0, 2, 1, 0, 3, 4] },
  'Gadd9':  { frets: [3, 0, 0, 2, 0, 3], fingers: [2, 0, 0, 1, 0, 3] },
  'Fmaj7':  { frets: ['x', 'x', 3, 2, 1, 0], fingers: [0, 0, 3, 2, 1, 0] },
  'Dadd9':  { frets: ['x', 'x', 0, 2, 3, 0], fingers: [0, 0, 0, 1, 2, 0] },
  'E7sus4': { frets: [0, 2, 2, 2, 0, 0], fingers: [0, 1, 2, 3, 0, 0] },
  'Bsus4':  { frets: ['x', 2, 4, 4, 5, 2], fingers: [0, 1, 2, 3, 4, 1], barre: { fret: 2, from: 5, to: 1 } },
  'Csus4':  { frets: ['x', 3, 3, 0, 1, 1], fingers: [0, 3, 4, 0, 1, 2] },
  'Db':     { frets: ['x', 4, 3, 1, 2, 1], fingers: [0, 4, 3, 1, 2, 1], barre: { fret: 1, from: 4, to: 1 } },
  'Ab':     { frets: ['x', 'x', 6, 5, 4, 4], fingers: [0, 0, 4, 3, 1, 2] },
  'Abm':    { frets: ['x', 'x', 6, 4, 4, 4], fingers: [0, 0, 3, 1, 1, 1], barre: { fret: 4, from: 4, to: 1 } },
  'Abm7':   { frets: [4, 6, 4, 4, 4, 4], fingers: [1, 3, 1, 1, 1, 1], barre: { fret: 4, from: 6, to: 1 } },
  'Bb5':    { frets: ['x', 1, 3, 3, 'x', 'x'], fingers: [0, 1, 3, 4, 0, 0] },
  'Gm5':    { frets: [3, 5, 5, 'x', 'x', 'x'], fingers: [1, 3, 4, 0, 0, 0] },
  'C5':     { frets: ['x', 3, 5, 5, 'x', 'x'], fingers: [0, 1, 3, 4, 0, 0] },
  'F7':     { frets: [1, 3, 1, 2, 1, 1], fingers: [1, 3, 1, 2, 1, 1], barre: { fret: 1, from: 6, to: 1 } },
  'Fm7b5':  { frets: [1, 'x', 1, 1, 0, 'x'], fingers: [2, 0, 3, 4, 0, 0] },
  'F/A':    { frets: ['x', 0, 3, 2, 1, 1], fingers: [0, 0, 4, 3, 1, 2] },
  'Bb/D':   { frets: ['x', 'x', 0, 3, 3, 1], fingers: [0, 0, 0, 3, 4, 1] },
  'Cm7':    { frets: ['x', 3, 5, 3, 4, 3], fingers: [0, 1, 3, 1, 2, 1], barre: { fret: 3, from: 5, to: 1 } },
  'G#m':    { frets: [4, 6, 6, 4, 4, 4], fingers: [1, 3, 4, 1, 1, 1], barre: { fret: 4, from: 6, to: 1 } },
  'G#m7':   { frets: [4, 6, 4, 4, 4, 4], fingers: [1, 3, 1, 1, 1, 1], barre: { fret: 4, from: 6, to: 1 } },
  'Cbmaj7': { frets: ['x', 2, 4, 4, 4, 6], fingers: [0, 1, 2, 3, 4, 4], barre: { fret: 4, from: 5, to: 1 } },
  'Gbmaj7': { frets: [2, 'x', 3, 3, 3, 'x'], fingers: [1, 0, 2, 3, 4, 0] },
};

// Given a chord name, return diagram data or null.
export function getChordShape(name) {
  if (!name) return null;
  const clean = name.trim();
  if (CHORDS[clean]) return CHORDS[clean];
  // Try enharmonic (e.g., F# vs Gb): not full mapping - skip
  return null;
}
